import React from 'react'

import { Card } from 'components/shared/Card/Card'
import { PaneHeader } from 'components/shared/PaneHeader/PaneHeader'
import { PaneTabsBar } from 'components/shared/PaneTabsBar/PaneTabsBar'

export const Pane = ({ children, className = undefined, tagName }) => (
  <Card {...{ className, tagName }}>{children}</Card>
)

Pane.Header = PaneHeader
Pane.TabsBar = PaneTabsBar
